<script>
  import { onMount } from "svelte";

  import StatsSales from "./StatsSales.svelte";
  import StatsSubscriptions from "./StatsSubscriptions.svelte";
  import StatsUpsells from "./StatsUpsells.svelte";
  import StatsTopPerformers from "./StatsTopPerformers.svelte";
  import { calcGroupingForTimeRange, DAY } from "../../Common/tools";
  import {External, M} from "../../external";

  let now = new Date();
  
  export let filters = [],
    funnelId = null,
    disabledStats = {},
    period = {
      label: "Last 7 days",
      id: "7-days",
      from: new Date(now.getTime() - 6 * DAY),
      to: now
    };

  let instance = null;
  let tab = "";
  let firstOrderTime = 0;
  let grouping = "monthly";
  let fragment = null;

  export function reload() {
    updateGrouping();

    setTimeout(() => {
      // important for this to be in a timeout so updates to the vars can first propagate
      instance.reload();
    }, 5);
  }

  let updateGrouping = () => {
    grouping = calcGroupingForTimeRange(firstOrderTime, period.from, period.to);
  };

  let changeTab = (newTab, newFragment) => {
    if (tab === newTab) {
      return;
    }
    fragment = newFragment ? newFragment : null;
    tab = newTab;
  };

  let showReferers = () => {
    changeTab("top", "sources");
  };

  onMount(function () {
    // The goal here is to check if there are any orders made. If not, show the intro. If yes, show the stats.
    // If there are orders, saving the first-order-time in localstorage so we don't call this method in the future
    // using the first order time is useful to also determine the grouping of orders in the graph if we're
    // showing all orders (i.e. show by day / week / month / year / etc)
    firstOrderTime = External.Website.firstOrderTime;
    if (!firstOrderTime) {
      firstOrderTime = External.createdTime;
    }
    updateGrouping();
    tab = "sales";
  });
</script>

<div class="upper-navigation upper-navigation-full mt-15">
  <ul>
    {#if disabledStats.sales !== false}
      <li><a class:active={tab === "sales"} on:click|preventDefault={() => changeTab("sales")}>{M.SALES_OVERVIEW}</a></li>
    {/if}
    {#if disabledStats.subscriptions !== false}
      <li><a class:active={tab === "subscriptions"} on:click|preventDefault={() => changeTab("subscriptions")}>{M.SUBSCRIPTIONS}</a></li>
    {/if}
    {#if disabledStats.upsells !== false}
      <li><a class:active={tab === "upsells"} on:click|preventDefault={() => changeTab("upsells")}>{M.UPSELLS_AND_DOWNSELLS}</a></li>
    {/if}
    {#if disabledStats.topPerformers !== false}
      <li><a class:active={tab === "top"} on:click|preventDefault={() => changeTab("top")}>{M.TOP_PERFORMERS}</a></li>
    {/if}
  </ul>
</div>
<div class="padding-45 f-left col20" style="padding-top:25px;">
  {#if tab === "sales" && disabledStats.sales !== false}
    <StatsSales
      bind:this={instance}
      filters={filters}
      grouping={grouping}
      funnel={funnelId}
      period={period}
      showReferers={disabledStats.referers !== false}
      on:showreferers={showReferers}
      on:filtersources />
  {:else if tab === "subscriptions" && disabledStats.subscriptions !== false}
    <StatsSubscriptions bind:this={instance} filters={filters} grouping={grouping} funnel={funnelId} period={period} on:showreferers={showReferers} />
  {:else if tab === "upsells" && disabledStats.upsells !== false}
    <StatsUpsells
      bind:this={instance}
      filters={filters}
      grouping={grouping}
      funnel={funnelId}
      period={period}
      showReferers={disabledStats.referers !== false}
      on:showreferers={showReferers}
      on:filtersources />
  {:else if tab === "top" && disabledStats.topPerformers !== false}
    <StatsTopPerformers bind:this={instance} tab={fragment} filters={filters} funnel={funnelId} period={period} />
  {/if}
</div>
